import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function SosAck() {
  const { id } = useParams();
  const [p] = useSearchParams();
  const q = { r: p.get("r"), t: p.get("t") };
  const [inc, setInc] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/sos/ack/${id}`, { params: q }).then((r) => setInc(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Link invalid"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const ack = async () => {
    try { await api.post(`/sos/ack/${id}`, null, { params: q }); setInc({ ...inc, status: "ACKNOWLEDGED", you: { ...inc.you, acknowledged_at: new Date().toISOString() } }); }
    catch (e) { setErr(e?.response?.data?.detail || e.message); }
  };
  if (err) return <div className="max-w-md mx-auto p-6 text-red-700 font-bold" data-testid="sos-ack-error">{err}</div>;
  if (!inc) return <div className="max-w-md mx-auto p-6">Loading…</div>;
  return (
    <div className="max-w-md mx-auto p-6 space-y-3" data-testid="sos-ack-page">
      <h1 className="text-2xl font-black text-red-700">SOS · {inc.kind.replace("_", " ")}</h1>
      <div className="rounded-2xl border border-stone-200 p-4 text-sm space-y-1">
        <div><b>{inc.user_name}</b> needs help</div>
        <div>{[inc.building, inc.floor && `Floor ${inc.floor}`, inc.lift_label && `Lift ${inc.lift_label}`].filter(Boolean).join(" · ") || "Location details not provided"}</div>
        {inc.people_count && <div>People inside: {inc.people_count}</div>}
        {inc.note && <div className="text-stone-600">“{inc.note}”</div>}
        {inc.location && <a className="underline text-sky-700" data-testid="sos-ack-map" href={`https://www.openstreetmap.org/?mlat=${inc.location.lat}&mlon=${inc.location.lng}#map=18/${inc.location.lat}/${inc.location.lng}`}>Open shared location</a>}
        <div className="text-xs text-stone-500">Status: {{ CREATED: "Alert created", ALERTS_ATTEMPTED: "Waiting for a responder", ACKNOWLEDGED: "Acknowledged", RESOLVED: "Resolved — person is safe", CANCELLED: "Cancelled by the person" }[inc.status] || inc.status}</div>
      </div>
      {inc.you.acknowledged_at ? (
        <div className="rounded-xl bg-emerald-100 text-emerald-900 font-bold p-3" data-testid="sos-ack-done">You acknowledged this alert.</div>
      ) : ["CREATED", "ALERTS_ATTEMPTED", "ACKNOWLEDGED"].includes(inc.status) ? (
        <button onClick={ack} data-testid="sos-ack-btn" className="w-full h-12 rounded-full bg-emerald-600 text-white font-black">I've seen this — I'm responding</button>
      ) : <div className="text-stone-600">This alert is closed.</div>}
      <a href="tel:112" className="block text-center font-bold text-red-700 underline" data-testid="sos-ack-call-112">Call 112 if they are in danger</a>
    </div>
  );
}
